import Download from "./Download";

export default Download;